<script setup>
defineProps({
  title: {
    type: String,
  },
  body: {
    type: String,
  },
  text: {
    type: String,
  },
})

function scrollToContactForm() {
  const el = document.getElementById('contactForm')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<template>
  <div class="side-promo-block">
    <div
      v-if="title"
      class="h2 side-promo-block__title"
    >
      {{ title }}
    </div>
    <div
      class="side-promo-block__body prose"
      v-html="body"
    />
    <UButton
      variant="solid"
      color="warning"
      :label="text"
      class="no-underline cursor-pointer"
      @click="scrollToContactForm"
    />
  </div>
</template>

<style lang="scss">
@use "@/assets/css/blocks/side-promo-block.scss";
</style>
